<template>
  <div class="h-100">
    <div class="body-content-overlay">
      <b-row class="match-height">
        <b-col
          lg="6"
          md="12"
        >
          <div>
            <img
              src="@/assets/img/logo/index_croll.png"
              width="60%"
              style="object-fit: contain;margin-left: 20%;margin-top: 20px"
            >
          </div>
        </b-col>
        <b-col
          lg="6"
          sm="6"
        >
          <div class="pitch">
            <h4 style="font-size: 2em;">
              {{ $t('Home.welcome') }}<span style="color: #0BDE8C;margin-left: 10px">MaxiPool</span>
            </h4>
            <p
              data-animation="fadeInLeft"
              data-delay=".8s"
              style="font-size: 22px;"
            >Starting Your Chia Mining With Us.
              Be part of the MaxiDAO. The DAO is built by the miners, of the miners, for the miners.</p>
            <b-row style="margin-top: 10px;" v-if="poolInfo">
              <b-col
                lg="3"
                sm="6"
              >
                <div class="stat">
                  <div class="label">
                    {{ $t('Home.GlobalNetspace') }}
                  </div>
                  <div class="value">
                    {{ $utils.getNetSpaceStr(poolInfo.netSpace) }}
                  </div>
                </div>
              </b-col>
              <b-col
                lg="3"
                sm="6"
              >
                <div class="stat">
                  <div class="label">
                    {{ $t('Home.PoolNetspace') }}
                  </div>
                  <div class="value">
                    {{ $utils.getNetSpaceStr(poolInfo.poolNetSpace) }}
                  </div>
                </div>
              </b-col>
              <b-col
                lg="3"
                sm="6"
              >
                <div class="stat">
                  <div class="label">
                    {{ $t('Home.FarmersOnline') }}
                  </div>
                  <div class="value">
                    {{ poolInfo.farmerCount }}
                  </div>
                </div>
              </b-col>
              <b-col
                lg="3"
                sm="6"
              >
                <div class="stat">
                  <div class="label">
                    {{ $t('Home.TimeWin') }}
                  </div>
                  <div class="value">
                    {{ getEstimatedTime(poolInfo.estimatedTime) }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <div v-if="poolInfo">
              <div style="font-size: 15px;font-weight: 700">
                Last 24 Hours
              </div>
              <b-row>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.BlocksFarmed') }}
                    </div>
                    <div class="value">
                      {{ poolInfo.farmerBlockCount24 }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHFarmed') }}
                    </div>
                    <div class="value">
                      {{ $utils.getReward(poolInfo.claimableTotal24) }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.Luck') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo.luck24, 1) }}%
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHByTen') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo.xchByTenTib24, 4) }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-if="poolInfo7d">
              <div style="font-size: 15px;font-weight: 700">
                Last 7 Days
              </div>
              <b-row>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.BlocksFarmed') }}
                    </div>
                    <div class="value">
                      {{ poolInfo7d.farmerBlockCount7d }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHFarmed') }}
                    </div>
                    <div class="value">
                      {{ $utils.getReward(poolInfo7d.claimableTotal7d) }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.Luck') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo7d.luck7d, 1) }}%
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHByTen') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo7d.xchByTenTib7d, 4) }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-if="poolInfo30d">
              <div style="font-size: 15px;font-weight: 700">
                Last 30 Days
              </div>
              <b-row>
                <b-col
                    lg="3"
                    sm="6">
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.BlocksFarmed') }}
                    </div>
                    <div class="value">
                      {{ poolInfo30d.farmerBlockCount30d }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHFarmed') }}
                    </div>
                    <div class="value">
                      {{ $utils.getReward(poolInfo30d.claimableTotal30d) }}
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.Luck') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo30d.luck30d, 1) }}%
                    </div>
                  </div>
                </b-col>
                <b-col
                    lg="3"
                    sm="6"
                >
                  <div class="stat">
                    <div class="label">
                      {{ $t('Home.XCHByTen') }}
                    </div>
                    <div class="value">
                      {{ $utils.getNumDecimal(poolInfo30d.xchByTenTib30d, 4) }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="chart-container">
        <div style="font-weight:400; font-size:30px;">
          {{ $t('Home.RecentPoolNetspace') }}
        </div>
        <e-charts
          ref="line"
          :key="1"
          autoresize
          :options="line"
          theme="theme-color"
          auto-resize
          style="width: 100%;height: 400px"
        />
      </div>
      <div
        class="chart-container1"
        style="padding-left: 5%;padding-right: 5%;margin-top: 40px"
      >
        <div style=" font-weight:400; font-size:30px;margin-bottom: 20px">
          {{ $t('Home.NewBlocks') }}
        </div>
        <div style="display: flex;width: 100%;">
          <div
            v-if="width>1024"
            class="table-column"
          >
            <div class="table-title">
              {{ $t('Home.Block') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
            >
              {{ item.height }}
            </div>
          </div>
          <div
            v-if="width>1024"
            class="table-column flexible"
          >
            <div class="table-title">
              {{ $t('Home.CoinHash') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
            >
              {{ item.coinhash }}
            </div>
          </div>
          <div class="table-column flexible">
            <div class="table-title">
              {{ $t('Home.Farmer') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
              style="color: #03b000;cursor: pointer;"
              @click="getDetail(item.farmer,index + 1 )"
            >
              {{ item.farmer }}
            </div>
          </div>
          <div class="table-column">
            <div class="table-title">
              {{ $t('Home.LuckValue') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
            >
              <div
                v-if="item.luck>=125"
                style="color:#03b000 "
              >
                {{ $t("Luck.VeryGood") }}
              </div>
              <div
                v-else-if="item.luck>=100&&item.luck<125"
                style="color:#03b000 "
              >
                {{ $t("Luck.Good") }}
              </div>
              <div v-else-if="item.luck>=75&&item.luck<100">
                {{ $t("Luck.Average") }}
              </div>
              <div
                v-else-if="item.luck>=50&&item.luck<75"
                style="color:#999999 "
              >
                {{ $t("Luck.NotVery") }}
              </div>
              <div
                v-else-if="item.luck>0&&item.luck<50"
                style="color:#999999 "
              >
                {{ $t("Luck.VeryBad") }}
              </div>
              <div v-else>
                {{ $t("Home.Undetermined") }}
              </div>
            </div>

          </div>
          <div class="table-column">
            <div class="table-title">
              {{ $t('Home.Date') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
            >
              {{ $utils.getTimeStr(item.timestamp) }}
            </div>
          </div>
          <div
            v-if="width>1024"
            class="table-column"
          >
            <div class="table-title">
              {{ $t('Home.Reward') }}
            </div>
            <div
              v-for="( item ,index ) in blockList"
              :key="index"
              class="table-text"
            >
              1.75XCH
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinVerticalLayout from '@/@core/layouts/layout-vertical/mixinVerticalLayout'
import {BCol, BRow} from 'bootstrap-vue'
import ECharts from 'vue-echarts'
import theme from '../../../@core/components/charts/echart/theme.json'

import walletAuth from '@/auth/wallet/auth'

ECharts.registerTheme('theme-color', theme)
export default {
  name: "Home",
  components: {
    BRow,
    BCol,
    ECharts,
  },
  mixins: [mixinVerticalLayout],
  data() {
    return {
      userData: JSON.parse(localStorage.getItem(walletAuth.config.userData) ? localStorage.getItem(walletAuth.config.userData) : '{}'),
      poolInfo: undefined,//首頁統計數據
      poolInfo7d: undefined,//首頁統計數據
      poolInfo30d: undefined,//首頁統計數據
      poolData: [],//统计图
      line: {},
      blockList: [],
      width: 1400,
    }
  },
  created() {
    this.resizeInit()
    this.getHome()
  },
  methods: {
    resizeInit() {
      this.resizeChange()
      const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
      window.addEventListener(resizeEvt, this.resizeChange, false)
      document.documentElement.addEventListener('DOMContentLoaded', this.resizeChange, false)
    },
    resizeChange() {
      this.width = document.body.clientWidth;
    },
    getHome() {
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      this.isLeaderboard = false;
      this.isDetails = false;
      this.$service.get('/farmer/getPoolInfo')
          .then(response => {
            this.poolInfo = response.data
          });
      this.$service.get('/farmer/getPoolInfo7d')
          .then(response => {
            this.poolInfo7d = response.data
          });
      this.$service.get('/farmer/getPoolInfo30d')
          .then(response => {
            this.poolInfo30d = response.data
          });
      this.$service.get('/farmer/getNeSpaceChart')
          .then(response => {
            this.poolData = response.data
            this.getData()
          });
      this.$service.get('/farmer/getHotBlockList')
          .then(response => {
            this.blockList = response.data
          });
    },
    getData() {
      var date = [];
      var list = this.poolData;
      var globalList = [];
      for (var i = 0; i < list.length; i++) {
        date.push(list[i].timestamp);
        globalList.push(this.$utils.getNumDecimal(list[i].plotSize / Math.pow(1024, 4), 6))
      }
      var that = this;
      this.line = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var showHtm = that.$utils.getTimeStr(params[0].name) + "<br />";
            for (var i = 0; i < params.length; i++) {
              //名称
              var name = params[i].seriesName;
              //值
              var value = params[i].value+" TiB";
              //颜色
              var color = '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:' + params[i].color + '"></span>'

              showHtm += color + name + ' ：' + value + '<br>'
            }
            return showHtm;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: date,
          axisLabel: {
            formatter: function (params, index) {
              var date1 = new Date(params * 1000);
              var h = date1.getHours();
              var mm = date1.getMinutes();
              return (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm)
            }
          },
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: ['rgba(204,204,204,0.3)'],
              width: 1,
              type: 'dotted'
            }
          }
        },
        yAxis: [{
          type: 'value',
          axisLabel: {formatter: '{value} TiB'},
          //网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: ['rgba(204,204,204,0.3)'],
              width: 1,
              type: 'dotted'
            }
          }
        }],
        series: [{
          name: 'Global',
          type: 'line',
          symbol:'none', //去掉折线图中的节点
          smooth: true, //true 为平滑曲线，false为直线
          sampling: 'none',
          itemStyle: {
            color: 'rgb(79, 202, 118)'
          },
          areaStyle: {
            opacity: 0.2,
            color: ECharts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgb(79, 202, 118)'
            }, {
              offset: 1,
              color: 'rgb(255, 255, 255)'
            }])
          },
          markLine : {
            data : [
              {type :'average', name: '平均值'}
            ],
            symbol: ['none', 'none'],
            position:"insideTopCenter",
            itemStyle:{
              normal:{
                lineStyle:{
                  type:'dotted',
                  color:'red'
                },
                label:{
                  show:true,
                  position:'middle',
                }
              }
            },
            large:true,
            effect:{
              show: false,
              loop: true,
              period: 0,
              scaleSize : 2,
              color : null,
              shadowColor : null,
              shadowBlur : null
            },
          },
          data: globalList
        },
        ]
      };
    },
    getEstimatedTime(time) {
      if (time == 0) {
        return this.$t('Home.Undetermined')
      }
      if (time < 60) {
        return time + this.$t('Second')
      } else if (time >= 60 && time < 3600) {
        return this.$utils.getNumDecimal(time / 60, 2) + this.$t('Minute')
      } else if (time >= 3600 && time < 86400) {
        return this.$utils.getNumDecimal(time / 3600, 2) + this.$t('Hour')
      } else {
        return this.$utils.getNumDecimal(time / 86400, 2) + this.$t('Day')
      }
    },
    getDetail(launcherId, index) {
      this.$router.push({
        path: '/main/details', query: {
          launcherId: launcherId,
          index: index
        }
      })
    },

  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

.table-title {
  font-weight: bold;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  overflow: hidden; /*溢出隐藏*/
  text-overflow: ellipsis; /*以省略号...显示*/
  white-space: nowrap; /*强制不换行*/
}

.table-text {
  padding: 10px;
  font-size: 15px;
  width: 100%;
  overflow: hidden; /*溢出隐藏*/
  text-overflow: ellipsis; /*以省略号...显示*/
  white-space: nowrap; /*强制不换行*/
}

.table-column {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  overflow: hidden;
}

.flexible {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  flex-shrink: 1;
}

.pitch {
  flex-basis: 0;
  flex-grow: 1;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  padding: 5px 5%;
}

.stat {
  width: 100%;
  margin-bottom: 5px;
  align-items: center;
  text-align: center;

  .label {
    color: #969696;
    min-width: 120px;
    white-space: nowrap;
  }

  .value {
    color: #08c904;
    font-size: 22px;
    overflow: hidden;
    white-space: nowrap;
  }

  .value1 {
    color: #03b000;
    font-size: 20px;
    overflow: hidden;
    white-space: nowrap;
  }
}

.chart-container {
  height: 400px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 90%;
  margin-left: 5%;
}


h4 {
  font-size: 2em;
  font-weight: 400;
  margin: .75em 0;
}
</style>
